import { render, staticRenderFns } from "./BusinessPayroll.vue?vue&type=template&id=59bfcc82&"
import script from "./BusinessPayroll.vue?vue&type=script&lang=ts&"
export * from "./BusinessPayroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports